// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__Xpd8d","header":"MergedInvoice_header__3XxG7"};